var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Row, Col, Grid } from "react-bootstrap";
import styled from "styled-components";
import { connect } from "@irati/store";
import { H2 } from "@irati/ui/src/Headings";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Button from "@irati/ui/src/Button";
import { RouterLink } from "@irati/ui/src/Link";
import padding from "@irati/ui/src/global/padding";
import { Para } from "@irati/ui/src/Labels";
import notFoundImage from "../../images/notFound.png";
var Image = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 100%;\n"], ["\n  max-width: 100%;\n"])));
var StyledRow = styled(Row)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 100px;\n  text-align: center;\n"], ["\n  margin-top: 100px;\n  text-align: center;\n"])));
var StyledDiv = styled("div")(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding-top: ", ";\n"], ["\n  padding-top: ", ";\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? "0px" : "100px");
});
var StyledPara = styled(Para)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: ", " 0 ", ";\n"], ["\n  padding: ", " 0 ", ";\n"])), padding.base, padding.small);
var NotFound = /** @class */ (function (_super) {
    __extends(NotFound, _super);
    function NotFound() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotFound.prototype.render = function () {
        var _a = this.props, buttonHref = _a.buttonHref, buttonText = _a.buttonText, formatMessage = _a.formatMessage, isMobile = _a.isMobile, text = _a.text;
        return (React.createElement(Grid, null,
            React.createElement(StyledRow, null,
                !isMobile &&
                    React.createElement(Col, { md: 6, xs: 12 },
                        React.createElement(Image, { alt: formatMessage({ id: "reward.notFound.image" }), src: notFoundImage })),
                React.createElement(Col, { md: 6, xs: 12 },
                    React.createElement(StyledDiv, { isMobile: isMobile },
                        React.createElement(H2, null,
                            React.createElement(FormattedMessage, { id: "reward.notFound.title" })),
                        React.createElement(StyledPara, { center: true, large: true },
                            React.createElement(FormattedMessage, { id: text })),
                        buttonHref && buttonText &&
                            React.createElement(RouterLink, { to: buttonHref },
                                React.createElement(Button, { primary: true },
                                    React.createElement(FormattedMessage, { id: buttonText }))))))));
    };
    NotFound.defaultProps = {
        text: "reward.notFound.text"
    };
    return NotFound;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isMobile: mq.lessThan.md
    });
};
export default injectIntl(connect(mapStateToProps)(NotFound));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
